import { useContext } from 'react';
import AppliedFiltersContext from '~/context/common/AppliedFiltersContext';
import FacetDataContext, {
  useFacetData
} from '~/context/common/FacetDataContext';
import type { AppliedListFilters } from '~/contracts/common';
import Checkbox from './Checkbox';
import FilterDrawer from './FilterDrawer';
import { CommonWrapper } from './FiltersMenu.styles';

type OwnProps = {
  checkboxClassName?: string;
  filterKey: keyof Omit<
    AppliedListFilters,
    'cvnaFeatureIds' | 'makes' | 'trims'
  >;
  title: string;
};

// This component only works when baseline and appliedFilters keys are identical
export default function SimpleCheckboxList({
  checkboxClassName,
  filterKey,
  title
}: OwnProps) {
  const { appliedFilters, updateListFilter } = useContext(
    AppliedFiltersContext
  );
  const { showInventoryCounts } = useContext(FacetDataContext);
  const facetData = useFacetData();
  const data = facetData[filterKey]?.buckets ?? [];
  const list: any[] = appliedFilters[filterKey] ?? [];

  return (
    <FilterDrawer
      testId={`facet-${filterKey}`}
      facetContent={data}
      facetName={title}
    >
      <CommonWrapper>
        {data.map(({ count, displayName, key }) => (
          <Checkbox
            className={checkboxClassName}
            checked={list.includes(key)}
            facet={filterKey}
            filter={key}
            id={`${filterKey}-${key}`}
            key={key}
            label={
              <span>
                {showInventoryCounts
                  ? `${displayName} (${count.toLocaleString()})`
                  : displayName}
              </span>
            }
            onChange={() =>
              updateListFilter({
                filterKey,
                value: key
              })
            }
          />
        ))}
      </CommonWrapper>
    </FilterDrawer>
  );
}
